import { Extension } from '@tiptap/core';

/**
 * Koppelt een tabelrij in het investeringsblok aan een product.
 *
 * De rij zelf blijft een gewone TipTap-tabelrij met tekstcellen — dat is wat de
 * editor, de preview en de PDF al kunnen. De koppeling hangt ernaast als
 * attributen, zodat we twee dingen kunnen die met alleen tekst niet gaan: zien
 * of een regel nog op de nieuwste productversie staat, en per product opvragen
 * in welke offertes het zit.
 *
 * De prijs in de cellen is en blijft een momentopname. Deze attributen wijzigen
 * daar niets aan; ze vertellen alleen waar de momentopname vandaan komt.
 */
export const InvestmentRowLink = Extension.create({
  name: 'investmentRowLink',

  addGlobalAttributes() {
    return [
      {
        types: ['tableRow'],
        attributes: {
          rateKey: { default: null, rendered: false },
          showHours: {
            default: null,
            parseHTML: (element) => element.hasAttribute('data-investment-show-hours')
              ? element.getAttribute('data-investment-show-hours') === 'true' : null,
            renderHTML: (attributes) => typeof attributes.showHours === 'boolean'
              ? { 'data-investment-show-hours': String(attributes.showHours) } : {},
          },
          investmentProduct: { default: null, rendered: false },
          productPrice: { default: null, rendered: false },
          productId: {
            default: null,
            parseHTML: (element) => element.getAttribute('data-product-id'),
            renderHTML: (attributes) =>
              attributes.productId ? { 'data-product-id': attributes.productId } : {},
          },
          productVersionId: {
            default: null,
            parseHTML: (element) => element.getAttribute('data-product-version-id'),
            renderHTML: (attributes) =>
              attributes.productVersionId
                ? { 'data-product-version-id': attributes.productVersionId }
                : {},
          },
          variantId: {
            default: null,
            parseHTML: (element) => element.getAttribute('data-variant-id'),
            renderHTML: (attributes) =>
              attributes.variantId ? { 'data-variant-id': attributes.variantId } : {},
          },
          quantity: {
            default: null,
            parseHTML: (element) => {
              const raw = element.getAttribute('data-quantity');
              return raw ? Number(raw) : null;
            },
            renderHTML: (attributes) =>
              attributes.quantity ? { 'data-quantity': String(attributes.quantity) } : {},
          },
          discountPct: {
            default: null,
            parseHTML: (element) => {
              const raw = element.getAttribute('data-discount-pct');
              return raw ? Number(raw) : null;
            },
            renderHTML: (attributes) =>
              attributes.discountPct ? { 'data-discount-pct': String(attributes.discountPct) } : {},
          },
          /** True zodra sales een berekend veld handmatig heeft ingevuld. */
          hasOverrides: {
            default: false,
            parseHTML: (element) => element.getAttribute('data-has-overrides') === 'true',
            renderHTML: (attributes) =>
              attributes.hasOverrides ? { 'data-has-overrides': 'true' } : {},
          },
        },
      },
    ];
  },
});

export default InvestmentRowLink;
